
// TODO - get this from backend somehow?
// these are typically used in badges or other UI components to indicate portal access status
const portalAccessConfig = {
  full: {
    variant: 'soft-success',
    label: 'Active',
  },
  open_invite: {
    variant: 'soft-primary',
    label: 'Open Invite',
  },
  expired_invite: {
    variant: 'soft-warning',
    label: 'Expired Invite',
  },
  on_hold: {
    variant: 'soft-danger',
    label: 'Deactivated',
  },
  invite_ready: {
    variant: 'soft-info',
    label: 'Invite Ready',
  },
  none: {
    variant: 'soft-secondary',
    label: 'No Access',
  },
};


const getPortalAccessParams = (key) => {
    // will include the 'key' as 'key'
  const portalAccessObj = portalAccessConfig[key] || null;
  if (portalAccessObj) {
    return {
      key,
      ...portalAccessObj,
    };
  }
  return null;
};

export {
  portalAccessConfig,
  getPortalAccessParams,
};